import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {takeUntil} from "rxjs/operators";
import {Meeting} from "../../../shared/interface/meeting";
import moment from "moment/moment";
import {AuthService} from "../../../shared/services/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {MeetingService} from "../../../shared/services/meeting.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {Observable, ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {IddTrainingTrainer} from "../../../shared/interface/idd-training-trainer";
import {IddTrainingTrainerService} from "../../../shared/services/idd-training-trainer.service";

@Component({
  selector: 'app-idd-trainings-trainer-details-view',
  templateUrl: './idd-trainings-trainer-details-view.component.html',
  styleUrls: ['./idd-trainings-trainer-details-view.component.scss']
})
export class IddTrainingsTrainerDetailsViewComponent implements OnInit, OnDestroy {
  @Input() iddTrainingTrainer: Observable<IddTrainingTrainer>;
  @Output() modifyClicked = new EventEmitter<any>();

  userPermissions: ReplaySubject<UserPermissions>;
  iddTrainingTrainerObject?: IddTrainingTrainer;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  constructor(
    private auth: AuthService,
    private dialog: MatDialog,
    private iddTrainingTrainerService: IddTrainingTrainerService,
    private snack: MatSnackBar,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.iddTrainingTrainer
      .pipe(takeUntil(this.destroyed$))
      .subscribe((iddTrainingTrainer: IddTrainingTrainer) => {
        this.iddTrainingTrainerObject = iddTrainingTrainer;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }
}
